module.exports = __webpack_public_path__ + "img/star_max.7f7ac3df.png";